module.exports = __webpack_public_path__ + "assets/fonts/Helvetica.ttf";